import { render, staticRenderFns } from "./Update.vue?vue&type=template&id=5a6a0c16&scoped=true"
import script from "./Update.vue?vue&type=script&lang=js"
export * from "./Update.vue?vue&type=script&lang=js"
import style0 from "./Update.vue?vue&type=style&index=0&id=5a6a0c16&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6a0c16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a6a0c16')) {
      api.createRecord('5a6a0c16', component.options)
    } else {
      api.reload('5a6a0c16', component.options)
    }
    module.hot.accept("./Update.vue?vue&type=template&id=5a6a0c16&scoped=true", function () {
      api.rerender('5a6a0c16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/Update.vue"
export default component.exports